import React from 'react';
import LegajoEmpleado from './LegajoEmpleado';

// Este componente ahora solo renderiza LegajoEmpleado
// para que referentes y empleados vean la misma interfaz
const Legajo = () => {
  return <LegajoEmpleado />;
};

export default Legajo;
